import { makeStyles } from '@material-ui/styles';

const styles = (theme) => ({
    // Card layout
    card: {
        backgroundColor: '#ffffff',
        padding: 24,
        borderRadius: 4,
        boxShadow: theme.customShadows.widget,
        marginTop: 16,
        width: '100%',
    },
    // PlansSelection + Upgrade button inline row
    upgradeRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        // justifyContent: 'center',
        gap: '12px',
        // marginBottom: 16,
    },
    addOnsHeading: {
        marginRight: 16,
        whiteSpace: 'nowrap',
    },
    // Add-on pills
    addOnsPillRow: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '8px',
        marginBottom: 16,
    },
    addOnsPill: {
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: 9999,
        border: `1px solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
        padding: '4px 12px',
        fontSize: 12,
        fontWeight: 600,
        whiteSpace: 'nowrap',
    },
    // Migrated from profile.styles
    addOnsSpace: {
        display: 'flex',
        flexDirection: 'row',
    },
    addOnsUpgrade: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
    },
    linkPointer: {
        cursor: 'pointer',
    },
    // Legacy — used by sections/AddOn.jsx prior to pill migration
    addOnsBox: {
        width: '100%',
        height: '56px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        border: '1px solid #dfdfdf',
        borderRadius: '4px',
        backgroundColor: '#fff',
        marginBottom: '16px',
        color: '#00000061',
    },
    addOnsName: {
        marginLeft: '16px',
    },
    addOnsValue: {
        marginRight: '16px',
        fontWeight: 'bold',
    },
        actionsRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '12px',
    },
});

export default styles;
export const useStyles = makeStyles(styles);
